module.exports = __webpack_public_path__ + "img/2A6276_041218_739BA6_042941-256px.be854724.png";